import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { useEffect, useState } from "react";
import { api } from "@/api";
import { OfficeLock } from "@/api/locks/locks";

export function NewLockHandbook(props: AutocompleteProps<OfficeLock>) {
  const [items, setItems] = useState<OfficeLock[]>([]);

  useEffect(() => {
    api.locks
      .list()
      .then((response) => {
        setItems(response.data);
      })
      .catch((err) => {
        console.error("Failed to load locks:", err);
      });
  }, []);

  return (
    <Autocomplete
      defaultItems={items}
      label="Замок"
      placeholder="Выберите замок"
      variant="bordered"
      {...props}>
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}
